import { render } from "./yearVote.vue?vue&type=template&id=2a929fec&scoped=true"
import script from "./yearVote.vue?vue&type=script&lang=ts"
export * from "./yearVote.vue?vue&type=script&lang=ts"

import "./yearVote.vue?vue&type=style&index=0&id=2a929fec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a929fec"

export default script